import React from 'react';
import { Users, CheckCircle2, Clock, ShieldAlert } from 'lucide-react';
import { WorkspaceUser } from '../types';

interface StatsBarProps {
  users: WorkspaceUser[];
  isLiveConnected: boolean;
}

export const StatsBar: React.FC<StatsBarProps> = ({ users, isLiveConnected }) => {
  const total = users.length;
  const synced = users.filter((u) => u.signatureStatus === 'synced').length;
  const pending = users.filter((u) => u.signatureStatus === 'pending').length;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 14,
        marginBottom: 20,
      }}
    >
      {/* Total Users */}
      <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 12,
            background: 'rgba(2, 132, 199, 0.15)',
            border: '1px solid rgba(2, 132, 199, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#0284c7',
          }}
        >
          <Users size={22} />
        </div>
        <div>
          <div style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>Pracownicy w Workspace</div>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#0B192C' }}>{total}</div>
        </div>
      </div>

      {/* Synced */}
      <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 12,
            background: 'rgba(16, 185, 129, 0.15)',
            border: '1px solid rgba(16, 185, 129, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#34d399',
          }}
        >
          <CheckCircle2 size={22} />
        </div>
        <div>
          <div style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>Zsynchronizowane stopki</div>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#10b981' }}>{synced}</div>
        </div>
      </div>

      {/* Pending */}
      <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 12,
            background: 'rgba(245, 158, 11, 0.15)',
            border: '1px solid rgba(245, 158, 11, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fbbf24',
          }}
        >
          <Clock size={22} />
        </div>
        <div>
          <div style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>Oczekujące na wdrożenie</div>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#f59e0b' }}>{pending}</div>
        </div>
      </div>

      {/* Sync Status / Google Workspace Connection */}
      <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 12,
            background: isLiveConnected
              ? 'rgba(16, 185, 129, 0.15)'
              : 'rgba(148, 163, 184, 0.15)',
            border: isLiveConnected
              ? '1px solid rgba(16, 185, 129, 0.3)'
              : '1px solid rgba(148, 163, 184, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: isLiveConnected ? '#34d399' : '#94a3b8',
          }}
        >
          <ShieldAlert size={22} />
        </div>
        <div>
          <div style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>Integracja Google API</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
            <span
              style={{
                display: 'inline-block',
                width: 8,
                height: 8,
                borderRadius: '50%',
                background: isLiveConnected ? '#10b981' : '#38bdf8',
                boxShadow: isLiveConnected ? '0 0 8px #10b981' : '0 0 8px #38bdf8',
              }}
            />
            <span style={{ fontSize: 13, fontWeight: 600, color: '#0B192C' }}>
              {isLiveConnected ? 'Połączono (Live)' : 'Tryb Bezpieczny'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
